/**
 * @file 论文管理API
 * @author 小白
 */

import request from "@/utils/request";
import { queryParams as qp } from "@/utils/function.js";

// 论文管理
export async function getListPaperMessage(data) {
  return request.post("/paperMessage/getListPaperMessage", data);
}

// 论文进度
export async function getProgressOfTheThesis(data) {
  return request.get(`/paperMessage/progressOfTheThesis/${data}`);
}

// 发送内容
export async function postInitiateGuidanceSend(data) {
  return request.post(`/paperMessage/initiateGuidanceSend`, data);
}

// 获取学生论文申请记录
export async function getStudentPaper(data) {
  return request.get(`/studentPaper`, data);
}

// 获取学生当前进行中/已通过的论文
export async function getStudentPaperQueryCurrent(data) {
  return request.get(`/studentPaper/queryCurrent`, data);
}

// 获取学生可申请论文列表
export async function getPaperApply(data) {
  return request.get(`/paperApply`, data);
}

// 申请论文
export async function paperApplyRecord(data) {
  return request.post(`/paperApplyRecord/apply/${data}`);
}

// 取消论文申请
export async function deletePaperApplyRecord(data) {
  return request.delete(`/paperApplyRecord/${data}`);
}

// 创建论文支付订单
export async function getGeneratePaperOrder(data) {
  return request.get(`/payment/generatePaperOrder${qp(data)}`);
}

// 根据学生论文ID获取学生当前状态
export async function getStudentPaperById(data) {
  return request.get(`/studentPaper/${data}`);
}

// 更新材料
export async function updatePaperApplyRecordDocument(data) {
  return request.post(`/paperApplyRecord/updateDocument`, data);
}

// 是否已经报名学位论文
export async function getIsApply() {
  return request.get(`/paperApplyRecord/isApply`);
}